export default __webpack_public_path__ + "static/media/Dhrek.9fe3e425.PNG";